var base = require('settings/subscription/subscribe-stripe');

Vue.component('spark-subscribe-stripe', {
    mixins: [base],

    props: [
        'countries'
    ],

    data: function(){
        return {
            features_modal: false
        };
    },

    methods: {
        showPlanDetails : function(plan) {
            this.features_modal = plan.id;
            this.detailingPlan = plan;
        },

        /**
         * Create a Stripe Card Element.
         */
        createCardElement(container){
            var card = this.stripe.elements().create('card', {
                hidePostalCode: true,
                style: {
                    base: {
                        '::placeholder': {
                            color: 'rgba(0,0,0,.50)'
                        },
                        fontFamily: 'Roboto,sans-serif',
                        color: 'rgba(0,0,0,.87)',
                        fontSize: '16px'
                    }
                }
            });

            card.mount(container);

            return card;
        }
    }
});
